import { useEffect, useState } from "react";
import { BuildJobInfo, JobType } from "../../../data/interfaces/jobmodels";
import { Box, Card, CardActionArea, CardContent, CardHeader, Divider, List, ListItem, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import jobService from "../../../data/api/job.service";
import { useNavigate } from "react-router-dom";

export default function BuildSummary(){
    const navigate=useNavigate();
    const [buildjobs, setBuildJobs] = useState<BuildJobInfo[]>([]);
    useEffect(()=>{
        jobService.getJobs(true,JobType.Build,"5","3",null,false,5).then((response)=>{
            setBuildJobs(response.data);
        })
    },[]);
    return(

        <Card>
            <CardHeader  title="Last 5 Build Jobs"/>
            <CardContent>
                <TableContainer>
                    <Table>
                        <TableBody>
                        {buildjobs.map((job)=>{
                        return(
                            <TableRow key={job.Id}>
                                <TableCell>{job.JobNumber}</TableCell>
                                    <TableCell>{job.Description}</TableCell>
                                    <TableCell>{job.CreatedDate}</TableCell>
                                    <TableCell>{job.CreatedUser}</TableCell>
                            </TableRow>
                        )
                    })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
            <CardActionArea sx={{textAlign:'center',p:1,color:'primary.main'}} onClick={()=>navigate('/jobs')}>
                <Typography variant="body1">View More</Typography> 
            </CardActionArea>
        </Card>
    );
}